import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Wrapper, Menu, MenuItem } from 'react-aria-menubutton';
import parseObjectTypeName from '../helpers/parseObjectTypeName';
import * as k from '../constants/constants';

class DropDown extends Component {
  constructor(props) {
    super(props);

    this.onClickHandler = this.onClickHandler.bind(this);
    this.state = {
      isOpen: false,
      openTop: false,
    };
  }

  onClickHandler(e) {
    let top = e.target.getBoundingClientRect().top;
    let isUnderMiddle = window.innerHeight / 2 < top ? true : false;
    this.setState({ openTop: isUnderMiddle });
  }

  render() {
    const elmClassName = (name) => {
      return this.props.componentName
        ? `${this.props.componentName}-${name}`
        : null;
    };
    const selectedModifier = (key) =>
      key === this.props.selected ? '--selected' : '';
    const defaultSelectedModifier = () =>
      this.props.selected === '' ? '--selected' : '';
    const optionClass = elmClassName('option');
    const defaultItem = this.props.defaultValue ? (
      <li key={this.props.defaultValue}>
        <MenuItem
          className={elmClassName('option') + defaultSelectedModifier()}
          value={this.props.defaultValue}
        >
          {this.props.defaultValueString}
        </MenuItem>
      </li>
    ) : null;

    const entry = Array.from(this.props.options).map(el => el[1]);
    const parented = entry.filter(el => el.get('parent'));
    const parentless = entry.filter(el => !el.get('parent'));

    let results = [];
    parentless.forEach((el, i) => {
      const childElems = parented.filter(p => p.get('parent') === el.get('name'));
      results.push(el);

      if (childElems.length > 0)
        results.push(...childElems);
    })

    const menuitems = results
				.map((item, key) => {
					const value = item.get('path') ? (key + 1).toString() : item.get('name');

					return (
						<li key={value}>
							<MenuItem
								className={`${
									item.get('parent') && item.get('parent').length ? 'small ' : ''
								}${optionClass + selectedModifier(value)}`}
								value={value}
							>
								{item.get('label')}
							</MenuItem>
						</li>
					);
				});

    return (
      <Wrapper
        className={this.props.className || this.props.componentName}
        onSelection={this.props.onSelected}
        onMenuToggle={({ isOpen }) => {
          this.setState({ isOpen });
        }}
        data-openstate={this.state.isOpen}
        data-opentop={this.state.openTop}
      >
        <Button
          className={elmClassName('select')}
          onMouseUp={this.onClickHandler}
        >
          {this.props.selected
            ? parseObjectTypeName(this.props.selected)
            : this.props.defaultValue}
        </Button>
        <Menu className={elmClassName('dropdown')}>
          <ul className={elmClassName('list')} ref="ul">
            {defaultItem}
            {menuitems}
          </ul>
        </Menu>
      </Wrapper>
    );
  }
}

DropDown.propTypes = {
  options: PropTypes.object,
  defaultValueString: PropTypes.string,
  defaultValue: PropTypes.string,
  onSelected: PropTypes.func,
};
DropDown.defaultProps = {
  options: {},
  defaultValueString: k.STR_ALL,
  defaultValue: '',
  onSelected: () => {},
};

export default DropDown;



// WEBPACK FOOTER //
// ./src/js/components/DropDown.js